<template>
	<div class="page">
		<div class="background"></div>
		<v-container class="content ma-n4 ma-sm-n8 pa-0" fluid>
			<v-row class="flex-column flex-sm-row" no-gutters>
				<v-col
						class="align-center d-flex info-container justify-center justify-sm-end"
						cols="12"
						sm="5"
				>
					<div class="align-center d-flex info-inner">
						<v-row>
							<v-col class="d-flex flex-column white--text">
								<v-img
										:class="{
										'my-4': $vuetify.breakpoint.xsOnly,
										'ms-n3': $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.mdAndUp,
										'ms-n2': $vuetify.breakpoint.smOnly,
										'align-self-center': $vuetify.breakpoint.xsOnly
									}"
										:max-width="logoWidth"
										src="/images/logo_bw_white.svg"
								></v-img>
								<v-divider class="my-8 w-100" dark></v-divider>
								<div v-if="$vuetify.breakpoint.smAndUp">
									<h5 class="font-weight-medium" style="line-height: 1.2 !important">
										Increased traffic means increased revenue for your business - now!
									</h5>
									<v-divider class="my-8 w-100" dark></v-divider>
									<div class="mt-12">
										<v-icon color="#ff876f" x-large>mdi-bullhorn-outline</v-icon>
										<div class="font-weight-bold mt-2 text-body-1">
											Marketing On Blast!
										</div>
										<span
												class="opacity-70 text-body-2 white--text"
												style="line-height: 1.2 !important"
										>
											{{ invite.partnerName }} has your back. Local businesses benefit
											from their local DMOs virtually shouting from the mountain tops to
											market the pass.
										</span>
									</div>
									<div class="mt-12">
										<v-icon color="#ff876f" x-large>mdi-access-point</v-icon>
										<div class="font-weight-bold mt-2 text-body-1">
											Trusted Local Network
										</div>
										<span class="opacity-70 text-body-2 white--text">
											Work with a partner and other local businesses that have your
											similar goals in mind.
										</span>
									</div>
									<div class="mt-12">
										<v-icon color="#ff876f" x-large>mdi-walk</v-icon>
										<div class="font-weight-bold mt-2 text-body-1">Feature Point 3</div>
										<span class="opacity-70 text-body-2 white--text">
											Feature point 3 subtext here.
										</span>
									</div>
								</div>
							</v-col>
						</v-row>
					</div>
				</v-col>
				<v-col
						class="align-center d-flex form-container justify-center justify-sm-start"
						cols="12"
						sm="7"
				>
					<div class="align-center d-flex form-inner">
						<v-row>
							<v-col class="align-center d-flex flex-column">
								<h1 class="mt-4 mt-sm-0 text-center text-h2 text-sm-h1">{{ heading }}</h1>
								<p
										class="grey--text text--darken-1 mt-4 mt-sm-8 text-center"
										:class="$vuetify.breakpoint.lgAndUp ? 'text-body-1' : 'text-body-2'"
								>
									{{ bodyMessage }}
								</p>

								<v-divider class="my-8 w-100"></v-divider>

								<v-row>
									<v-col>
										<v-form ref="form" v-model="formIsValid" style="min-width: 300px">
											<div>
												<v-text-field
														v-model="firstName"
														autocomplete="off"
														class="rounded-lg required"
														label="First Name"
														outlined
														:rules="rules.firstName"
												></v-text-field>
											</div>
											<div>
												<v-text-field
														v-model="lastName"
														class="rounded-lg required"
														label="Last Name"
														outlined
														:rules="rules.lastName"
												></v-text-field>
											</div>
											<div>
												<v-text-field
														v-model="user.email"
														class="rounded-lg required"
														label="Email"
														outlined
														:rules="rules.email"
														type="email"
												></v-text-field>
											</div>
											<div>
												<vue-tel-input-vuetify
														ref="phone"
														v-model="user.phone"
														append-icon="mdi-menu-down"
														class="required rounded-lg"
														clearable
														:defaultCountry="countryCode"
														label="Phone"
														mode="international"
														outlined
														:preferred-countries="['us', 'ca']"
														:rules="rules.phone"
														@input="phoneInputEvent"
														@keydown="phoneKeyEvent"
												></vue-tel-input-vuetify>
											</div>
											<div>
												<v-text-field
														v-model="user.password"
														:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
														class="rounded-lg required"
														label="Password"
														outlined
														placeholder=""
														:rules="rules.password"
														:type="showPassword ? 'text' : 'password'"
														@click:append="showPassword = !showPassword"
												>
													<template v-slot:message="{ key, message }">
														<span :inner-html.prop="message"></span>
													</template>
												</v-text-field>
											</div>
											<div>
												<!--												ironclad overwrites the html for this div-->
												<div id="IronClad" ref="IronClad"></div>
												<v-checkbox
														v-model="userTos"
														:value="'agreed'"
														class="required hidden ironclad-checkbox"
														required
														:rules="rules.userTos"
												></v-checkbox>
											</div>
										</v-form>
									</v-col>
								</v-row>

								<v-progress-linear
										v-if="loading"
										class="mb-8 w-100"
										color="secondary"
										height="2"
										indeterminate
								></v-progress-linear>
								<v-divider v-if="!loading" class="mb-8 w-100"></v-divider>

								<v-row class="w-100" no-gutters>
									<v-col align-self="center">
										<div class="align-center d-flex">
											<div>
												<v-icon class="me-2">mdi-chevron-left</v-icon>
											</div>
											<div
													class="flex-grow-1 grey--text text-caption"
													style="line-height: 1.2"
											>
												No thanks, I don't want
												<br/>
												increased business.
											</div>
										</div>
									</v-col>
									<v-col cols="auto">
										<v-btn
												class="rounded-lg"
												color="primary"
												depressed
												:disabled="!formIsValid"
												:large="$vuetify.breakpoint.smAndDown"
												:loading="loading"
												:x-large="$vuetify.breakpoint.mdAndUp"
												@click.stop="onSubmit"
										>
											Create Account
											<v-icon class="me-n2 ms-2">mdi-chevron-right</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>

import $api from "@api/api";
import IronClad from '@services/IronClad/api';

export default {
	name: 'CreateAccount',
	props: {
		campaign: {
			type: Object,
			default: () => ({})
		},
		countryCode: {
			type: String,
			default: () => 'US'
		},
		invite: {
			type: Object,
			default: () => ({})
		},
		partner: {
			type: Object,
			default: () => ({})
		},
		user: {
			type: Object,
			default: () => ({})
		},
		userPartners: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			loading: false,
			firstName: this.user?.name?.trim().split(' ')[0],
			formIsValid: false,
			lastName: this.user?.name?.trim().split(' ')[1],
			phoneIsValid: false,
			rules: {
				email: [
					v => !!v || 'Email is required.',
					v => {
						const pattern =
								// eslint-disable-next-line max-len
								/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return pattern.test(v) || 'Please enter a valid e-mail.';
					}
				],
				firstName: [v => !!v || 'First name is required.'],
				lastName: [v => !!v || 'Last name is required.'],
				password: [
					v => !!v || 'Password is required.',
					// v => v?.length >= 8 || 'Password must be at least 8 characters.',
					// v => v?.length <= 32 || 'Password must be 32 characters or less.',
					v => {
						const passes = {
							num: false,
							lower: false,
							upper: false,
							special: false,
							len: false
						};
						const patterns = {
							num: /\d+/,
							lower: /[a-z]+/,
							upper: /[A-Z]+/,
							special: /[*.!@$%^&(){}[\]:;<>,?/~_+\-=|]+/,
							len: /^.{8,32}$/
						};
						Object.keys(patterns).forEach(key => {
							passes[key] = patterns[key].test(v);
						});
						return (
								!Object.keys(passes).some(key => !passes[key]) ||
								`Password must contain: <ul class="mt-2 password-list"><li class="${
										passes.upper && 'success--text'
								}">One uppercase letter</li><li class="${
										passes.lower && 'success--text'
								}">One lowercase letter</li><li class="${
										passes.num && 'success--text'
								}">One number</li><li class="${
										passes.special && 'success--text'
								}">One special character</li><li class="${
										passes.len && 'success--text'
								}">8-32 characters</li></ul>`
						);
					}
				],
				phone: [
					v => !!v || 'Phone is required.',
					() => this.phoneIsValid || 'Please enter a valid phone.'
				],
				userTos: [v => !!v && v === 'agreed' || 'Please agree to the terms']
			},
			showPassword: false,
			userTos: "",
			ironCladAgreement: window.location.href.includes('app.bandwango.com') ? 3 : 1
		};
	},
	computed: {
		bodyMessage() {
			return this.invite.statusCode === 'accepted'
					? "Let's finish setting up your user account so you can get in there and see everything that's going on."
					: "That's ok! Why don't we finish setting up your account so you can be invited to other passes... or maybe change your mind on this one?";
		},
		heading() {
			return this.invite.statusCode === 'accepted'
					? `Invite Accepted${this?.firstName ? `, ${this.firstName}` : ''}!`
					: `Oh No${this?.firstName ? `, ${this.firstName}` : ''}!`;
		},
		logoWidth() {
			if(this.$vuetify.breakpoint.xsOnly) return 144; // height = 80
			if(this.$vuetify.breakpoint.mdAndUp) return 180;
			return 120;
		}
	},
	methods: {
		async save() {
			return new Promise(async resolve => {
				// should we add confirm to the form?
				const user = _.pick(this.user, [
					'first_name',
					'last_name',
					'email',
					'phone',
					'password'
				]); // only pass what we update
				user.password_confirmation = user.password;
				user.require_new_password = 0;

				const url = `/admin-portal/${this.partner.id}/users/main/update-user/${this.user.id}`;
				axios
						.put(url, user)
						.then(() => {
							window.EventBus.$emit('system-messages', [
								{ message: 'User updated - redirecting now...', messageType: 'success' }
							]);
							setTimeout(() => {
								if(this.invite.id)
									window.location.href = `/admin-portal/${this.partner.id}/invites/view/invite/${this.invite.id}`;
								else
									window.location.href = `/admin-portal/${this.partner.id}/dashboard/main/view-dashboard`;
							}, 4000);
							resolve();
						})
						.catch(error => {
							this.loading = false;
							window.EventBus.$emit('system-messages', [
								{ message: error.message, messageType: 'error' }
							]);
							resolve();
						});
			});
		},
		onSubmit() {
			const isValid = this.$refs.form.validate();
			if(!isValid) return (this.formIsValid = false);

			this.loading = true;

			if(this.user.require_new_password) {
				// firstVisit = true;
				this.user.require_new_password = '0';
			}
			// TODO: should we add confirm password in the form? It is required for the api call
			this.user.password_confirmation = this.user.password;

			this.save();
		},
		phoneInputEvent(formattedNumber, { valid }) {
			// Only flip the form validity to false if NOT valid, do nothing on valid = true
			if(!valid) this.formIsValid = false;
			// For field validation rule
			this.phoneIsValid = valid;
		},
		phoneKeyEvent(e) {
			const validCharsRegex = new RegExp(/^[0-9 +\-()]*$/);

			// Allow Control+V or Command+V for pasting
			const isPasteOperation = (e.key === 'v' || e.key === 'V') && (e.ctrlKey || e.metaKey);

			if(!validCharsRegex.test(e.key) && ![
				'ArrowLeft',
				'ArrowRight',
				'Backspace',
				'Delete',
				'Tab'
			].includes(e.key) && !isPasteOperation) {
				e.preventDefault();
			}
		},
	},
	async mounted() {

		const self = this;
		// Ironclad field
		setTimeout(async () => { // _ps needs time to load
			const { data: agreement } = await $api.agreements.getAgreement(this.ironCladAgreement);
			if(agreement) {
				const group = await IronClad.groups.getGroup(agreement.external_id, this.user.email, { container_selector: 'IronClad' });
				if(group) {
					group.render();

					// TODO:: move this logic to the IronClad api. Kind of hacky
					// _ps is a global js object
					_ps.on('valid', function (params, context) {
						if(params.group === group.parameters?.data?.values[':group'])
							self.userTos = "agreed";

						console.log(params, context, self.userTos);
					});
					_ps(agreement.external_id + ":retrieveHTML", {
						fullName: this.user.name,
						userId: this.user.id,
						agreementId: agreement.id,
						agreementAssignmentId: this.user.id
					});
				}
			}
		}, 750);
	},
};
</script>

<style lang="scss" scoped>
// @import '~vuetify/src/styles/styles.sass';
@import '~vuetify/src/styles/settings/_variables'; // breakpoints

.page {
	position: relative;
}

.background {
	background-image: url('/images/portals/welcome-alert-bg.jpg');
	background-position: center center;
	background-size: cover;
	bottom: 0;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	transform: rotate(180deg) scaleX(-1);
	z-index: 1;

	@media #{map-get($display-breakpoints, 'xs-only')} {
		transform: scaleY(-1);
	}
}

.content {
	min-height: 100vh;
	min-width: 100vw;
	position: relative;
	z-index: 2;
}

.info-container {
	overflow: hidden;

	@media #{map-get($display-breakpoints, 'sm-and-up')} {
		min-height: 100vh;
	}
}

.form-container {
	background-color: rgba(255, 255, 255, 0.6);
	overflow: hidden;

	@media #{map-get($display-breakpoints, 'sm-and-up')} {
		min-height: 100vh;
	}
}

.info-inner {
	backdrop-filter: blur(30px);
	background: rgba(255, 255, 255, 0.1);
	border-top-left-radius: map-get($rounded, 'xl');
	border-bottom-left-radius: map-get($rounded, 'xl');
	box-shadow: 0 12px 76px 3px rgba(47, 68, 104, 0.28),
	0 5px 92px 8px rgba(47, 68, 104, 0.24), 0 6px 30px 0 rgba(47, 68, 104, 0.4); //rgb(0 67 133)
	min-height: calc(100% - 4vw);
	padding: 3vw;
	width: calc(100% - 2vw);

	@media #{map-get($display-breakpoints, 'sm-and-up')} {
		min-height: calc(100% - 10vw);
		padding: 4vw;
		width: calc(100% - 5vw);
	}

	@media #{map-get($display-breakpoints, 'md-and-up')} {
		min-height: calc(100% - 20vw);
		padding: 5vw;
		width: calc(100% - 10vw);
	}

	@media #{map-get($display-breakpoints, 'xs-only')} {
		border-top-left-radius: map-get($rounded, 'xl');
		border-bottom-left-radius: 0;
		border-top-right-radius: map-get($rounded, 'xl');
		margin-top: 5vw;
		min-height: unset;
		width: calc(100% - 10vw);
	}
}

.form-inner {
	background: rgba(255, 255, 255, 0.9);
	border-top-right-radius: map-get($rounded, 'xl');
	border-bottom-right-radius: map-get($rounded, 'xl');
	box-shadow: 0 12px 76px 3px rgba(100, 136, 170, 0.14),
	0 5px 92px 8px rgba(100, 136, 170, 0.12), 0 6px 30px 0 rgba(100, 136, 170, 0.2); //rgb(0 67 133)
	min-height: calc(100% - 4vw);
	padding: 2vw;
	width: calc(100% - 2vw);

	@media #{map-get($display-breakpoints, 'sm-and-up')} {
		min-height: calc(100% - 10vw);
		padding: 3vw;
		width: calc(100% - 5vw);
	}

	@media #{map-get($display-breakpoints, 'md-and-up')} {
		min-height: calc(100% - 20vw);
		padding: 5vw;
		width: calc(100% - 10vw);
	}

	@media #{map-get($display-breakpoints, 'xs-only')} {
		border-top-right-radius: 0;
		border-bottom-right-radius: map-get($rounded, 'xl');
		border-bottom-left-radius: map-get($rounded, 'xl');
		margin-bottom: 5vw;
		min-height: calc(100vh - 21vw - 56px - 1rem);
		width: calc(100% - 10vw);
	}
}

#IronClad {
	min-height: 3rem;
}

.ironclad-checkbox {
	display: none !important;
}
</style>
